import { ErrorCode, reportError } from '@ms/yammer-data/dist/telemetry';
import React, { PureComponent } from 'react';
export default class ErrorBoundary extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined,
        };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error) {
        reportError({
            error,
            eventProperties: {
                errorBoundaryName: this.props.name,
                errorCode: ErrorCode.ErrorBoundary,
            },
        });
    }
    render() {
        const { ErrorComponent: Error, children } = this.props;
        return this.state.error ? (React.createElement("div", { className: "qaErrorBoundary" },
            React.createElement(Error, { error: this.state.error }))) : (children);
    }
}
//# sourceMappingURL=ErrorBoundary.js.map